import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AudioModel } from '@store/slices/audio.slice'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'

const sectionEndpoint = 'audio/'

export const generateAudioForText = createAsyncThunk(
  'audio/generateTmpAudio',
  async (props: { voice: EntityId | null; text: string }) => {
    try {
      const response = await api.post(
        `${sectionEndpoint}generate-from-editor/`,
        {
          data: props.text,
          voice: props.voice ? props.voice : null,
        }
      )

      return response.data.data as AudioModel
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se vygenerovat úsek'}`
        )
      } else {
        toast.error('Nepodařilo se vygenerovat úsek')
      }
      throw axiosError
    }
  }
)

export const generateHeaderPreview = createAsyncThunk(
    'audio/generateHeaderPreview',
    async (props: { broadcastId: EntityId | null; text: string }) => {
        try {
            const response = await api.post(
                `${sectionEndpoint}generate-header-preview/`,
                {
                    headers: props.text,
                    broadcast: props.broadcastId ? props.broadcastId : null,
                }
            )

            return response.data.data as AudioModel
        } catch (error) {
            const axiosError = error as AxiosError
            if (axiosError.response) {
                const serverError = axiosError.response.data as DjangoErrorResponse
                toast.error(
                    `Chyba: ${serverError.message || 'Nepodařilo se vygenerovat úsek'}`
                )
            } else {
                toast.error('Nepodařilo se vygenerovat úsek')
            }
            throw axiosError
        }
    }
)

export const fetchAudioOutsideStore = createAsyncThunk(
  'audio/fetchAudioOutsideStore',
  async (audioId: EntityId) => {
    try {
      const response = await api.get(`${sectionEndpoint}${audioId}/`)

      return response.data as AudioModel
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se vygenerovat zpráv'}`
        )
      } else {
        toast.error('Nepodařilo se vygenerovat zpráv')
      }
      throw axiosError
    }
  }
)
